module.exports = __webpack_public_path__ + "img/rbxpier.13222b8b.svg";